import { BaseLogHelper } from './base/base.log.helper';

export class SignatureLog extends BaseLogHelper {
  static logID = 'signature-flow';

  static logSignatureGenerationFailure(url: string, error: any) {
    return this.logError({
      msg: `${this.logID}: generation failed`,
      extra: {
        url,
        error,
      },
    });
  }
}
